import PropTypes from 'prop-types'
import React, { Component } from 'react'

import StickySquare from 'components/StickySquare'
import { GOODS_TYPES } from 'constants/sales'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import DistributionBannerContainer from 'containers/DistributionBannerContainer'
import { LocalizationConsumer } from 'contexts/Localization'
import { MenuMainConsumer } from 'contexts/MenuMain'
import { ResizeContext } from 'contexts/Resize'
import { LastBlock } from 'styles/components/layout'
import {
  grass,
  white,
  pictonBlue,
  materialRed,
  orange,
  black,
} from 'styles/theme/colors'

import DHowAnalyse from './components/DHowAnalyse'
import DHowFirst from './components/DHowFirst'
import DHowInterpreting from './components/DHowInterpreting'
import DHowOrder from './components/DHowOrder'
import DHowProtection from './components/DHowProtection'
import DHowRegister from './components/DHowRegister'
import DHowResults from './components/DHowResults'
import DHowReturn from './components/DHowReturn'
import DHowSpit from './components/DHowSpit'

const STICKY_SQUARE_BG_COLORS = [
  grass,
  white,
  pictonBlue,
  materialRed,
  white,
  pictonBlue,
  orange,
]
const STICKY_SQUARE_TEXT_COLORS = [
  black,
  black,
  black,
  white,
  black,
  white,
  black,
]

class DnaHowItWorks extends Component {
  constructor(props) {
    super(props)

    this.blocks = STICKY_SQUARE_BG_COLORS.map(() => React.createRef())
    this.state = {
      stickySquareActive: false,
    }
  }

  activateSticky = () => this.setState({ stickySquareActive: true })

  deactivateSticky = () => this.setState({ stickySquareActive: false })

  render() {
    const { texts, pathCdn, locale } = this.props
    const { stickySquareActive } = this.state
    const viewport = this.context
    const isMobile = !!(viewport.mobile && viewport.breakpoint !== '')

    return (
      <>
        <DHowFirst data={texts.first} secondBlockRef={this.blocks[0]} />

        <div ref={this.blocks[0]}>
          <DHowOrder
            {...{ pathCdn }}
            index={1}
            data={texts.order_dna}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[1]}>
          <DHowRegister
            index={2}
            data={texts.register_kit}
            isSquareHidden={stickySquareActive}
            {...{ locale }}
          />
        </div>

        <div ref={this.blocks[2]}>
          <DHowSpit
            index={3}
            data={texts.spit}
            isSquareHidden={stickySquareActive}
            {...{ locale }}
          />
        </div>

        <div ref={this.blocks[3]}>
          <DHowReturn
            index={4}
            data={texts.return_kit}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[4]}>
          <DHowAnalyse
            index={5}
            data={texts.analyse}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[5]}>
          <DHowInterpreting
            index={6}
            data={texts.interpreting}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[6]}>
          <LocalizationConsumer>
            {({ locale }) => (
              <DHowResults
                index={7}
                data={texts.get_results}
                pathCdn={pathCdn}
                locale={locale}
                isSquareHidden={stickySquareActive}
              />
            )}
          </LocalizationConsumer>
        </div>

        <div className="pt-4">
          <DHowProtection data={texts.protection} />
        </div>

        <LastBlock>
          <CartSaleWideContainer
            className="pt-2 pt-md-4"
            productType={GOODS_TYPES.dna}
          />

          <DistributionBannerContainer />
        </LastBlock>

        {!isMobile && (
          <MenuMainConsumer>
            {({ menuNode }) => (
              <StickySquare
                topOffsetNode={menuNode}
                isActive={stickySquareActive}
                blocks={this.blocks}
                squareColors={STICKY_SQUARE_BG_COLORS}
                textColors={STICKY_SQUARE_TEXT_COLORS}
                activateStickyHandler={this.activateSticky}
                deactivateStickyHandler={this.deactivateSticky}
              />
            )}
          </MenuMainConsumer>
        )}
      </>
    )
  }
}

DnaHowItWorks.contextType = ResizeContext

DnaHowItWorks.propTypes = {
  pathCdn: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
}

export default DnaHowItWorks
